import { useEffect, useState } from 'react';

// Returns a debounced copy of value that only updates after it has been
// stable for the given delay. Cleans up the pending timeout on unmount
// and when value/delay change.
const useDebouncedValue = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handle = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => clearTimeout(handle);
    }, [value, delay]);

    return debouncedValue;
};

export default useDebouncedValue;
